module.exports = __webpack_public_path__ + "static/img/devices-section.107ca7a.svg";